export default __webpack_public_path__ + "static/media/pic1.b5c79158.jpg";